(() => {
  if (customElements.get('artplex-latest')) return;
  customElements.define('artplex-latest', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.buttons = [...this.querySelectorAll('[data-goto]')];
      this.pause = this.querySelector('[data-pause]');
      this.announcement = this.querySelector('[data-announcement]');
      this.active = 0;
      this.paused = this.dataset.autoplay !== 'true';
      this.hovered = false;
      this.onscreen = false;
      this.duration = Math.max(7000, Number(this.dataset.duration) || 10000);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const on = (target, type, handler) => target.addEventListener(type, handler, {signal: this.controller.signal});
      on(this, 'click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {event.preventDefault(); return;}
        const target = event.target.closest('button');
        if (!target) return;
        if (target.hasAttribute('data-goto')) this.go(Number(target.dataset.goto), true);
        else if (target.hasAttribute('data-step')) this.go(this.active + Number(target.dataset.step), true);
        else if (target === this.pause) {this.paused = !this.paused; this.sync();}
      });
      on(this, 'focusin', event => {
        if (event.target !== this.pause) {this.paused = true; this.sync();}
      });
      on(this, 'keydown', async event => {
        if (!event.target.closest('.al-navigation') || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.active + (event.key === 'ArrowRight' ? 1 : -1);
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.slides.length - 1;
        await this.go(index, true);
        this.buttons[this.active].focus({preventScroll:true});
      });
      on(this, 'pointerenter', event => {if (event.pointerType === 'mouse') {this.hovered = true; this.sync();}});
      on(this, 'pointerleave', event => {if (event.pointerType === 'mouse') {this.hovered = false; this.sync();}});
      on(this, 'pointerdown', event => {
        if (event.isPrimary && event.pointerType !== 'mouse' && event.target.closest('.al-viewport')) this.touch = {x:event.clientX,y:event.clientY};
      });
      on(this, 'pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x, dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5) {
          event.preventDefault(); this.suppressClickUntil = performance.now()+450;
          this.go(this.active+(dx<0?1:-1),true);
        }
      });
      on(this, 'pointercancel', () => {this.touch = null;});
      on(document, 'visibilitychange', () => this.sync());
      on(this.motion, 'change', () => this.sync());
      on(document, 'shopify:block:select', event => {
        const slide = event.target.closest('[data-slide]');
        if (slide && this.contains(slide)) this.go(this.slides.indexOf(slide),true);
      });
      this.observer = new IntersectionObserver(entries => {this.onscreen = entries[0].isIntersecting; this.sync();}, {threshold:.3});
      this.observer.observe(this);
      this.dataset.ready = 'true';
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      const stopped = this.paused || this.motion.matches;
      this.pause.disabled = this.motion.matches || this.slides.length<2;
      this.pause.setAttribute('aria-pressed',String(stopped));
      this.pause.setAttribute('aria-label',this.motion.matches?this.dataset.reduced:stopped?this.dataset.play:this.dataset.pause);
      this.pause.firstElementChild.textContent = stopped?'▷':'Ⅱ';
      if (!stopped && !this.hovered && this.onscreen && !document.hidden && this.slides.length>1) this.timer = setTimeout(()=>this.go(this.active+1,false),this.duration);
    }
    async go(index,manual) {
      const next = (index+this.slides.length)%this.slides.length;
      if (manual) this.paused = true;
      const selected = this.slides[next];
      const version = this.loadVersion = (this.loadVersion || 0) + 1;
      clearTimeout(this.timer);
      this.setAttribute('aria-busy','true');
      selected.querySelectorAll('img').forEach(img=>{img.loading='eager';});
      selected.querySelectorAll('[data-srcset]').forEach(el=>{el.srcset=el.dataset.srcset;el.removeAttribute('data-srcset');});
      selected.querySelectorAll('[data-src]').forEach(el=>{el.src=el.dataset.src;el.removeAttribute('data-src');});
      await Promise.allSettled([...selected.querySelectorAll('img')].map(img=>img.decode()));
      if (version !== this.loadVersion || !this.isConnected) return;
      this.removeAttribute('aria-busy');
      this.slides.forEach((slide,i)=>{slide.hidden=i!==next;slide.inert=i!==next;slide.setAttribute('aria-hidden',String(i!==next));});
      this.buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===next)));
      this.active=next;
      this.dataset.active=String(next);
      if (manual) this.announcement.textContent = selected.getAttribute('aria-label');
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.loadVersion = (this.loadVersion || 0) + 1;
      this.controller?.abort();this.controller=null;
      this.observer?.disconnect();
    }
  });
})();
